import { SelectOption } from 'form';

export const paymentMethodOptions: SelectOption[] = [
  { label: 'Telegraphic Transfer', value: 'TT' },
  { label: 'Documents Against Payment', value: 'DP' },
];
export const sellerPaymentEventOptions: SelectOption[] = [
  { label: 'Collection from supplier', value: 'CL' },
  { label: 'Export', value: 'XP' },
  { label: 'Site delivery', value: 'SD' },
];
export const buyerPaymentEventOptions: SelectOption[] = [
  { label: 'Collection from supplier', value: 'CL' },
  { label: 'Export', value: 'XP' },
  { label: 'BOL date', value: 'BL' },
  { label: 'Destination port arrival', value: 'DA' },
  { label: 'ICD arrival', value: 'IA' },
  { label: 'Site delivery', value: 'SD' },
];
